import api from './api.js'
import { get, post } from './http.js'

let request = {};
for (let key in api) {
  const list = api[key];
  request[key] = request[key] || {};
  list.map(item => {
    const url = item.base.url;
    const method = item.base.method;
    request[key][item.name] = (params, pathArray = []) => {
      if (!params) {
        params = {}
      }

      // 合并本次调用里控制 loading 的参数到 config（例如 noloading）
      let config = item.config || {};
      if (Object.prototype.hasOwnProperty.call(params, 'noloading')) {
        config = {
          ...config,
          noloading: params.noloading
        }
      }

      switch (method) {
        case 'post': {
          return post(url, params, config, item.base.headers);
        }
        // 默认是get
        default: {
          return get(url + pathArray.join('/'), params, config, item.base.headers);
        }
      }
    }
  })
}
export default request